// extracted by mini-css-extract-plugin
module.exports = {"link":"ExpertReview_link__8qPsg","link-disabled":"ExpertReview_link-disabled__2BYwa"};